import React from "react";
import Header from "../components/FrontPage/Header/Header";
import Footer from "../components/Footer/Footer";
import LeftDrawer from "../components/Dashboard/Drawers/LeftDrawer";
import Eurowag from "./static/EurowagFuel";
import ScrollToTopOnMount from "../helpers/ScrollToTop";

const EurowagFuel = ({ USER }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <Header />
      <Eurowag />
      <Footer />
      {USER && <LeftDrawer small />}
    </>
  );
};

export default EurowagFuel;
